module.exports = __webpack_public_path__ + "static/media/heroimage_igib-024.c9186ce7.jpg";